const pcOpts = {
  DISCOUNTCOUPON: '#order-create-coupon',
  OLDMONEYDOM: '.origin-amount',
  FREIGHTDOM: '.ship',
  PAYNEWDPM: '.total-amount',
  ORIGINDOM: '.detail'
}
const phoneOpts = {
  DISCOUNTCOUPON: '.table-view-cell.table-view-cell-arr.order-coupon',
  OLDMONEYDOM: '.table-view-cell.table-view-cell-noborder',
  ORIGINDOM: '.table-view.order-bill',
  CREATEORDERBUTTON: '.create-order-amount-wrap span'
}

export {pcOpts, phoneOpts}



// WEBPACK FOOTER //
// ./src/common/util/orderUIConfig.js